const START_PAGE = '/';
const MAIN_MAP = '/main_map';
const AIRCRAFTS_MAP = '/aircrafts_map';
const AIRCRAFTS_CARDS = '/aircrafts_cards';
const CREW_AVAILABILITY = '/crew_availability';
const ERRORS = '/errors';
const STATISTICS = '/statistics';
const HUBS_REPORT = '/hubs_report';
const WEATHER = '/weather';
const WEATHER_WINDS = '/weather_winds';
const SETTINGS = '/settings';
const STATS = '/stats/*';
const STATS_FR = '/stats/fr';
const STATS_FH = '/stats/fh';
const STATS_UPTIME = '/stats/uptime';
const STATS_DOWNTIME = '/stats/downtime';
const STATS_MTTR = '/stats/mttr';
const STATS_MTBA = '/stats/mtba';
const STATS_AOGDR = '/stats/aogdr';

const PAGE_NOT_FOUND = '/404';
const NO_ACCESS = '/403';
const LOGOUT = '/logout';

export const routes = {
  START_PAGE,
  MAIN_MAP,
  AIRCRAFTS_MAP,
  AIRCRAFTS_CARDS,
  CREW_AVAILABILITY,
  ERRORS,
  STATISTICS,
  PAGE_NOT_FOUND,
  LOGOUT,
  HUBS_REPORT,
  WEATHER,
  WEATHER_WINDS,
  SETTINGS,
  STATS,
  STATS_FR,
  STATS_FH,
  STATS_UPTIME,
  STATS_DOWNTIME,
  STATS_MTTR,
  STATS_MTBA,
  STATS_AOGDR,
  NO_ACCESS,
};
